import React, { useEffect, useState } from 'react';
import styles from './PersonalizedRecommendations.module.scss';
import { Container } from 'reactstrap';
import FilterTabsCommon from '../../common/FilterTabsCommon/FilterTabsCommon';
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';

const fiterTabs = [
    { id: '1', label: 'Product Title Optimization' },
    { id: '2', label: 'Description Enhancement' },
    { id: '3', label: 'Category Correction' },
    { id: '4', label: 'Video Check' },
    { id: '5', label: 'Image Quality Check' },
];

const customStyles = {
    header: {
        style: {
            fontSize: '20px',
            padding: '0',

            div: {
                fontWeight: '600',
            }
        },
    },
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "16px",
            paddingRight: "16px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 16px',
        },
    },
};

const tabTableConfigs = {
    '1': {
        columns: [
            { name: 'Product Name', selector: row => row.productName },
            { name: 'Current Title', selector: row => row.currentTitle },
            { name: 'Recommended Title', selector: row => row.recommendedTitle },
            { name: 'Reason for Change', selector: row => row.reason },
        ],
        rows: [
            { productName: 'Blue colored headphones', currentTitle: '"Headphones"', recommendedTitle: '"Blue Wireless Headphones with Mic"', reason: 'More descriptive, includes keywords' },
            { productName: 'Blue colored headphones', currentTitle: '"Headphones"', recommendedTitle: '"Blue Wireless Headphones with Mic"', reason: 'More descriptive, includes keywords' },
            { productName: 'Blue colored headphones', currentTitle: '"Headphones"', recommendedTitle: '"Blue Wireless Headphones with Mic"', reason: 'More descriptive, includes keywords' },
            { productName: 'Blue colored headphones', currentTitle: '"Headphones"', recommendedTitle: '"Blue Wireless Headphones with Mic"', reason: 'More descriptive, includes keywords' },
        ],
    },
    '2': {
        columns: [
            { name: 'Product Name', selector: row => row.productName, width: '300px' },
            { name: 'Current Description', selector: row => row.currentDesc, width: '300px' },
            { name: 'Recommended Description', selector: row => row.recommendedDesc, width: '500px' },
            { name: 'Reason for Change', selector: row => row.reason },
        ],
        rows: [
            {
                productName: 'Blue colored headphones', currentDesc: '"Great sound quality."',
                recommendedDesc: '"Experience unparalleled sound quality with our Blue Wireless Headphones featuring a built-in microphone and long battery life."',
                reason: 'More detailed, includes features and benefits'
            },
            {
                productName: 'Blue colored headphones', currentDesc: '"Great sound quality."',
                recommendedDesc: '"Experience unparalleled sound quality with our Blue Wireless Headphones featuring a built-in microphone and long battery life."',
                reason: 'More detailed, includes features and benefits'
            },
        ],
    },
    '3': {
        columns: [
            { name: 'Product Name', selector: row => row.productName },
            { name: 'Current Category', selector: row => row.category },
            { name: 'Recommended Title', selector: row => row.recommendedTitle },
            { name: 'Reason for Change', selector: row => row.reason },
        ],
        rows: [
            { productName: 'Blue colored headphones', category: '"Electronics"', recommendedTitle: '"Electronics > Audio > Headphones"', reason: 'More specific, improves searchability' },
            { productName: 'Blue colored headphones', category: '"Electronics"', recommendedTitle: '"Electronics > Audio > Headphones"', reason: 'More specific, improves searchability' },
            { productName: 'Blue colored headphones', category: '"Electronics"', recommendedTitle: '"Electronics > Audio > Headphones"', reason: 'More specific, improves searchability' },
            { productName: 'Blue colored headphones', category: '"Electronics"', recommendedTitle: '"Electronics > Audio > Headphones"', reason: 'More specific, improves searchability' },
        ],
    },
    '4': {
        columns: [
            { name: 'Product Name', selector: row => row.productName },
            { name: 'Current Video', selector: row => row.currentVideo },
            { name: 'Recommended Title', selector: row => row.recommendedTitle },
            { name: 'Reason for Change', selector: row => row.reason },
        ],
        rows: [
            { productName: 'Blue colored headphones', currentVideo: 'No video', recommendedTitle: 'Add a product demo video', reason: 'Increases engagement, provides visual detail' },
            { productName: 'Blue colored headphones', currentVideo: 'Low-quality video', recommendedTitle: 'Update with a high-definition video', reason: 'Better showcases the product' },
            { productName: 'Blue colored headphones', currentVideo: 'Outdated video', recommendedTitle: 'Refresh with a current style video', reason: 'Appeals to modern audience' },
            { productName: 'Blue colored headphones', currentVideo: 'Outdated video', recommendedTitle: 'Refresh with a current style video', reason: 'Appeals to modern audience' },
        ],
    },
    '5': {
        columns: [
            { name: 'Product Name', selector: row => row.productName },
            { name: 'Current Images', selector: row => row.currentImgs },
            { name: 'Recommended Action', selector: row => row.recommendedAction },
            { name: 'Reason for Change', selector: row => row.reason },
        ],
        rows: [
            { productName: 'Blue colored headphones', currentImgs: 'Low resolution, 2 images', recommendedAction: 'Add high-resolution images', reason: 'Enhances visual appeal, provides more views' },
            { productName: 'Blue colored headphones', currentImgs: '3 images, poorly lit', recommendedAction: 'Add well-lit, professional images', reason: 'Improves clarity, attracts more buyers' },
            { productName: 'Blue colored headphones', currentImgs: '3 images, poorly lit', recommendedAction: 'Add well-lit, professional images', reason: 'Improves clarity, attracts more buyers' },
            { productName: 'Blue colored headphones', currentImgs: '3 images, poorly lit', recommendedAction: 'Add well-lit, professional images', reason: 'Improves clarity, attracts more buyers' },
        ],
    },
};

const PersonalizedRecommendations = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('1');
    const [tableColumns, setTableColumns] = useState([]);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        // Retrieve the selected tab from route state
        if (location.state && location.state.selectedTab) {
            const selected = location.state.selectedTab;
            setActiveTab(selected);
        }
    }, [location.state]);

    useEffect(() => {
        // Update table data and columns based on the active tab
        const config = tabTableConfigs[activeTab];
        setTableColumns(config?.columns || []);
        setTableData(config?.rows || []);
    }, [activeTab]);

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Personalized Recommendations</h4>

            <div className={styles.filterContainer}>
                <FilterTabsCommon
                    tabs={fiterTabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>

            <Container fluid className={styles.scheduleContainer}>
                <div className={styles.table}>
                    <DataTable
                        columns={tableColumns}
                        data={tableData}
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </Container>
        </div>
    );
};

export default PersonalizedRecommendations;